import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_WITH_STATE_TRANSITIONS_QUERY = gql`
  query documentTypeWithStateTransitions($id: Int!) {
    documentTypeWithStateTransitions(id: $id) {
      id
      name
      stateTransitions {
        id
        documentTypeId
        fromStateId
        fromStateName
        fromStateIsActive
        toStateId
        toStateName
        toStateIsActive
        saveImage
        requiresConfirmation
        notifyResponsible
        notifyUser
        isInitial
        isFinal
        userGroups {
          documentAllowedTransitionId
          userGroupId
        }
        userGroupsNotification {
          documentAllowedTransitionId
          userGroupId
        }
      }
    }
  }
`;
